<template>
  <div class="advance-search-result">
    <!-- a search panel that can be folded -->
    <el-collapse v-model="activeNames">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="icon-title">
            <img
              :src="require('@/assets/images/SearchPage/search.png')"
              alt="检索"
              class="icon"
            />
            <span class="title">高级检索</span>
          </div>
        </template>
        <div class="inner-content">
          <advanced-search-form ref="searchForm"></advanced-search-form>
          <div class="side-help">
            <div class="help-text">
              <div class="help-title">
                高级检索使用方法
              </div>
              <div class="help-content">
                请输入检索词。可用“+”表示“与”，“空格”表示“或”，"-"表示非
                进行组合检索
                <br />
                <br />
                例如：
                <br />
                （1）黄芪+人参可以检索到包含黄芪和人参的相关内容；
                <br />
                （2）黄芪 人参可以检索到包含黄芪或人参的相关内容；
                <br />
                （3） -黄芪 可以检索不包含黄芪的内容。
                <br />
                <br />
                对于成书区间的检索：
                （1）若起始年份输入-500，终止年份输入1000，则检索结果为公元前500年到1000年的所有成书。
                <br />
                （2）年份只能输入数字（如-500，1000等），且起始年份不能大于终止年份。
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="content">
      <div class="side-bar">
        <RetrieveLeftMenu ref="leftMenu"></RetrieveLeftMenu>
      </div>
      <div class="main-content">
        <retrieve-result ref="retrieveResult"></retrieve-result>
      </div>
    </div>
  </div>
</template>

<script>
import AdvancedSearchForm from '../../components/AdvancedSearchForm.vue'
import RetrieveLeftMenu from '../../components/RetrieveLeftMenu.vue'
import RetrieveResult from './RetrieveResult.vue'
export default {
  components: { AdvancedSearchForm, RetrieveLeftMenu, RetrieveResult },
  name: 'AdvancedSearchResult',
  data () {
    return {
      activeNames: []
    }
  },
  mounted () {
    let searchFormData = JSON.parse(localStorage.getItem('advancedSearchForm'))
    let typeStr = ''
    this.form = searchFormData
    if (this.form.type instanceof Array && this.form.type.length === 1) {
      // 获取所有的子分类
      console.log(this.form.type)
      for (let i = 0; i < this.classifyList.length; i++) {
        if (this.classifyList[i].name === this.form.type[0]) {
          for (let name of this.classifyList[i].children) {
            typeStr += name.value + ' '
          }
        }
      }
    }

    if (this.form.type instanceof Array && this.form.type.length > 1) {
      typeStr = this.form.type[this.form.type.length - 1]
    }

    this.$global.advancedSearchDTO = {
      bookName: this.form.name,
      classification: typeStr,
      author: this.form.author,
      edition: this.form.edition,
      completionDynasty: this.form.age,
      librarySite: this.form.location,
      description: this.form.abstract,
      text: this.form.fullText,
      directory: this.form.catalog,
      completionTime: [
        this.form.from === '' ? -1 : this.form.from,
        this.form.to === '' ? -1 : this.form.to
      ],
      currentPage: 1,
      pageSize: 10,
      sortingMethod: '',
      reverseOrder: 0,
      exactSearch: this.form.fuzzySearch ? 0 : 1,
      userId: localStorage.getItem('userId'),
      sideBarInfo: {
        sideBarClassify: [],
        sideBarLibrarySite: [],
        sideBarDynasty: [],
        sideBarYear: [],
        sideBarEdition: [],
        sideBarAuthor: []
      }
    }
    // alert(JSON.stringify(this.$global.advancedSearchDTO));
    if (searchFormData) {
      this.$refs.searchForm.form = searchFormData
    }
    localStorage.removeItem('advancedSearchForm')
  },
  watch: {
    $route (to, from) {
      this.$refs.retrieveResult.firstSearch = true
      let searchFormData = JSON.parse(
        localStorage.getItem('advancedSearchForm')
      )

      let typeStr = ''
      this.form = searchFormData
      if (this.form.type instanceof Array && this.form.type.length === 1) {
        // 获取所有的子分类
        console.log(this.form.type)
        for (let i = 0; i < this.classifyList.length; i++) {
          if (this.classifyList[i].name === this.form.type[0]) {
            for (let name of this.classifyList[i].children) {
              typeStr += name.value + ' '
            }
          }
        }
      }

      if (this.form.type instanceof Array && this.form.type.length > 1) {
        typeStr = this.form.type[this.form.type.length - 1]
      }

      this.$global.advancedSearchDTO = {
        bookName: this.form.name,
        classification: typeStr,
        author: this.form.author,
        edition: this.form.edition,
        completionDynasty: this.form.age,
        librarySite: this.form.location,
        description: this.form.abstract,
        text: this.form.fullText,
        directory: this.form.catalog,
        completionTime: [
          this.form.from === '' ? -1 : this.form.from,
          this.form.to === '' ? -1 : this.form.to
        ],
        currentPage: 1,
        pageSize: 10,
        sortingMethod: '',
        reverseOrder: 0,
        exactSearch: this.form.fuzzySearch ? 0 : 1,
        userId: localStorage.getItem('userId'),
        sideBarInfo: {
          sideBarClassify: [],
          sideBarLibrarySite: [],
          sideBarDynasty: [],
          sideBarYear: [],
          sideBarEdition: [],
          sideBarAuthor: []
        }
      }
      // this.$refs.retrieveResult.getSearchInfo()
      this.activeNames.splice(0, this.activeNames.length)
    }
  }
}
</script>

<style scoped>
.advance-search-result {
  width: 1200px;
  margin: 0 auto;
}

.advance-search-result >>> .el-collapse-item__header {
  padding: 0;
}

.advance-search-result >>> .el-collapse-item__content {
  font-size: 16px;
  overflow: visible;
}

.icon-title {
  display: flex;
  align-items: center;
  justify-content: left;
  width: 156px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
  margin-left: 20px;
}

.content {
  width: 1200px;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}

.side-bar {
  width: 220px;
  height: 810px;
  background-color: #fff;
  margin: 0;
  margin-right: 30px;
}

.main-content {
  margin: 0;
  width: 910px;
  height: 760px;
  background-color: #fff;
  padding-left: 20px;
  padding-top: 10px;
  padding-right: 20px;
  padding-bottom: 40px;
  overflow-y: auto;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}

.inner-content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}

.side-help {
  width: 300px;
  height: 810px;
  background-color: #fff;
}

.help-title {
  font-size: 16px;
  font-weight: bold;
  color: #634c37;
  margin-bottom: 10px;
}

.help-content {
  font-size: 14px;
  color: #634c37;
  line-height: 1.5;
}

.help-text {
  width: 162px;
  padding: 14px;
  background: rgba(244, 242, 241, 0.26);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #f4f2f1;
  text-align: left;
  margin: auto;
  margin-top: 54px;
}

.advance-search-result >>> .el-cascader .el-input__icon:before {
  color: #634c37;
  font-size: 24px;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/views/retrieve/AdvancedSearchResult.vue